import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import classes from './ExpensePage.module.scss';
import Expense from '../../../Components/pages/expense/Expense';
import { getExpense } from '../../../actions/expense';
import { getPlacements } from '../../../actions/constFromApi';
import { generalEnums } from '../../../utils/enums';
import { PageContext } from '../../../context/context';
import LoadingWithSpinner from '../../../Components/common/LoadingWithSpinner/LoadingWithSpinner';

export default function ExpensePage() {
  const params = useParams();
  const dispatch = useDispatch();
  const expense = useSelector((state) => state.expense.data);
  const ctx = useContext(PageContext);

  useEffect(() => {
    dispatch(getExpense(params?.id, localStorage.getItem('UserId')));
    ctx.setPageType(generalEnums.EXPENSE);
  }, [params, ctx]);

  useEffect(() => {
    if (expense?.ClientCompanyId) {
      dispatch(getPlacements(expense?.ClientCompanyId));
    }
  }, [expense?.ClientCompanyId]);

  return <section className={classes.pageContainer}>{expense?.Status ? <Expense /> : <LoadingWithSpinner />}</section>;
}
